import React, { useMemo } from 'react';

import { useModelDetails, usePredicates } from '@mpm-druid/api';
import { PanelExtraOptions, Panel as PanelType } from '@mpm-druid/types';
import { calculateDateRange } from '@mpm-druid/utils';
import { useModelViewStore } from '../modelViewStore';
import { PythonPanel } from './PythonPanel';

function PanelComponent({ panel }: { panel: PanelType }) {
  const dateRange = useModelViewStore(state => state.view.data.dateRange);
  const modelId = useModelViewStore(state => state.view.model_id);
  const modelVersion = useModelViewStore(state => state.view.data.modelVersion);
  const filterBatchId = useModelViewStore(
    state => state.view.data.filterBatchId
  );
  const { data: modelName } = useModelDetails(
    { modelId },
    {
      refetchOnMount: false,
      select: data => data.model.name,
      staleTime: Infinity,
      cacheTime: Infinity
    }
  );
  const { data: filters } = usePredicates({
    predicatesBatchId: filterBatchId
  });

  const [startDate, endDate] = useMemo(() => {
    return calculateDateRange(dateRange);
  }, [dateRange]);

  const intervalType = dateRange.intervalType;
  const extraOptions = useMemo<PanelExtraOptions | null>(() => {
    if (!modelName) {
      return null;
    }

    return {
      endDate,
      filters: (filters || []).filter(Boolean),
      intervalType,
      modelId,
      modelName,
      modelVersion,
      startDate
    };
  }, [
    endDate,
    filters,
    intervalType,
    modelId,
    modelName,
    modelVersion,
    startDate
  ]);

  if (!extraOptions) {
    return null;
  }

  if (panel.data.type === 'python') {
    return (
      <PythonPanel
        config={panel.data.config}
        id={panel.id}
        extraOptions={extraOptions}
      />
    );
  }

  return <div>Non-supported panel type: {panel.data.type}</div>;
}

export const Panel = React.memo(PanelComponent);
